import { PLATFORM_DATA_CONFIG } from 'common/constants';

export const getAccountMembersUrl = (
  workspaceId: string,
  organizationId: string,
): string => {
  return `${PLATFORM_DATA_CONFIG.ACCOUNTS_URI}/app/workspaces/members?workspace=${workspaceId}&organization=${organizationId}`;
};

export const getAccountWorkspacesUrl = (
  workspaceId: string,
  organizationId: string,
): string => {
  return `${PLATFORM_DATA_CONFIG.ACCOUNTS_URI}/app/workspaces?workspace=${workspaceId}&organization=${organizationId}`;
};
